import { createAction, props } from "@ngrx/store";
import { masterTransactionsTableTabName, MasterViewTypes } from "../../shared/utilities/Constants";
import { MasterTransactionsTableColumn } from "../../shared/types/MasterTransactionsTableColumn";

export const gridReady = createAction(
  '[Create Request - Master Transactions Table] AG Grid Ready',
  props<{ gridReady: boolean, tab: masterTransactionsTableTabName }>()
)

export const currentTabUpdated = createAction(
  '[Create Request - Master Transactions Table] User changed tab',
  props<{ currentTab: masterTransactionsTableTabName }>()
);

export const hasEmptyResponse = createAction(
  '[Create Request - Master Transactions Table] Empty response for table'
);

export const setCurrentViewedTransaction = createAction(
  '[Create Request - Master Transactions Table] - Map cashiering transaction',
  props<{ masterTransaction: MasterTransactionsTableColumn }>()
)

export const loadViewPage = createAction(
  '[Create Request - Master Transactions Table] Load View Page',
  props<{ viewType: MasterViewTypes }>()
);
export const printFriendlyClicked = createAction(
  '[Create Request - Master Transactions Table] User Requested Print Friendly'
);

export const refresh = createAction(
  '[Create Request - Master Transactions Table] Refresh Overview Data',
  props<{ accountId: string }>()
);
